import { h, Fragment } from 'preact'
import classnames from 'classnames'


export function Checkbox(props) {

	const { 
		label, 
		count, 
		size = 'medium', 
		fill,
		block,
		onChange, 
		class: className,
		style,
		...attributes
	} = props

	const changeHandler = onChange ? event => {
		if (!event.currentTarget) return
		onChange(event, event.currentTarget.checked)
	} : undefined
	
	const classes = classnames(
		'ui-checkbox',
		size && `ui-checkbox--${size}`,
		fill && 'ui-checkbox--fill',
		block && 'ui-checkbox--block',
		className
	)

	return <>
		<label class={classes} style={style}>
			<input class="ui-checkbox__input" type="checkbox" onChange={changeHandler} {...attributes} /> 
			<span class="ui-checkbox__box">
				<Check class="ui-checkbox__check" />
			</span>
			<span class="ui-checkbox__label">{label}</span>
			{count && <span class="ui-checkbox__count">{count}</span>}
		</label>
	</>
}

function Check({ round = true, class:className, ...attributes }) {
	return <svg class={className} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
		<path 
			d="M1 5.71698L4.13953 9L11 3" 
			stroke="black" 
			stroke-width="1.6"
			stroke-linecap={round && 'round' || undefined} 
			stroke-linejoin={round && 'round' || undefined}
		/>
	</svg>
}
